import { render, staticRenderFns } from "./ArtistView.vue?vue&type=template&id=284cceec&scoped=true"
import script from "./ArtistView.vue?vue&type=script&lang=ts"
export * from "./ArtistView.vue?vue&type=script&lang=ts"
import style0 from "./ArtistView.vue?vue&type=style&index=0&id=284cceec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284cceec",
  null
  
)

export default component.exports